mutation RenderPsdTemplate(
    $campaignId: ID!
    $computedLayers: [InputComputedLayer]!
    $masterTemplate: InputMasterTemplate!
) {
    renderPsdTemplate(campaignId: $campaignId, computedLayers: $computedLayers, masterTemplate: $masterTemplate)
}
